import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className='footer modern-footer' id='company'>
      <div className='container'>
        <div className='footer-bottom'>
          <p>© 2025 Cinquity All Rights Reserved</p>
          <div className='footer-legal-bottom'>
            <Link to='/privacy' className='footer-legal-link'>
              Privacy
            </Link>
            <Link to='/legal' className='footer-legal-link'>
              Legal
            </Link>
            <Link to='/terms' className='footer-legal-link'>
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
